<template>
    <div>

        <form method="POST" :action="route" accept-charset="UTF-8" >

            <input name="chartRoles[model_chart]" type="hidden" :value="model_chart">
            <input name="chartRoles[charts_id][]" v-for="chart_id in charts_id" :key="chart_id" type="hidden" :value="chart_id">

          <div class="form-group">
            <div class="alert alert-warning" role="alert">
                {{__("forms.changeMassiveRole.info_1")}}
            </div>
            <label for="person_id" class="">{{__('forms.PayItemsPeople.person')}}</label>
            <select class="form-control" name="chartRoles[person_id]" required @change="getWorkflowRolesOfPerson($event)">
              <option value="">---</option>
                <option v-for="person in actor_people" :key="person.id" :value="person.id">
                  {{person.fullName}}
                </option>
            </select>
          </div>
          <div class="alert alert-warning" role="alert">
              {{__("forms.changeMassiveRole.info_2")}}
          </div>
          <div class="form-group">
            <label for="workflow_role_id" class="">{{__('forms.EvaluationChart.workflowRole')}}</label>
            <select class="form-control" @change="insertWorkflowRole($event)">
              <option value="">---</option>
              <option v-for="workflowRole in personWorkflowRoles" :key="workflowRole.id" :value="workflowRole.id">
                {{workflowRole.name}}
              </option>
            </select>
          </div>
          <div class="profile-content-block section-with-border">
              <div class="row" v-for="workflowRole in workflowRoleForChange">
                <div class="col-2">
                  <a href="#" @click="removeWorkflowRole(workflowRole.id)" >
                    <i style="color: red" class="fa fa-times-circle" aria-hidden="true"></i>
                  </a>
                </div>
                <div class="col-10">
                      {{workflowRole.name}}
                  </div>
              </div>
          </div>
          <div class="form-group" v-for="workflowRole in workflowRoleForChange">
              <label>
                {{__("forms.changeMassiveRole.forWorkflowRole_1")}} {{workflowRole.name}}, {{__("forms.changeMassiveRole.forWorkflowRole_2")}}
              </label>
              <select class="form-control" :name="'chartRoles[workflowRoleChange]['+workflowRole.id+']'" required>
                <option value="">---</option>
                <option v-for="person in all_people" :key="person.id" :value="person.id">
                    {{person.fullName}}
                </option>
              </select>
          </div>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="_method" value="PUT">
          <div class="form-buttons clear">
            <button type="submit" class="btn btn--green">{{ __('misc.update') }} </button>
          </div>
        </form>

    </div>
</template>

<script>

  export default {

    data () {
      return {

          parameters: {},
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          workflowRoleForChange : [],
          personWorkflowRoles : []
      }
    },
    methods: {
        getWorkflowRolesOfPerson(event){

          let chartRoles = {
                'charts_id' : this.charts_id,
                'person_id' : event.target.value
          };

          axios.get('/get-person-workflow-role-in-charts/'+encodeURI(this.model_chart),{ params: {
                chartRoles : chartRoles
              }
          })
          .then((response) => {
              this.workflowRoleForChange = []; //Reset previous association
              this.personWorkflowRoles = response.data ;
          });
        },
        insertWorkflowRole(event){
            let workflow_role_id = event.target.value;

            let alreadyPresent = this.workflowRoleForChange.filter(obj => {
              return obj.id === parseInt(workflow_role_id)
            });
            if(alreadyPresent.length > 0){
              return;
            }
            let workflowRole = this.workflow_roles.filter(obj => {
                return obj.id === parseInt(workflow_role_id)
            });
            if(workflowRole.length > 0){
              this.workflowRoleForChange.push(workflowRole[0]);
            }
        },
        removeWorkflowRole(workflow_role_id){

            this.workflowRoleForChange = this.workflowRoleForChange.filter(obj => {
                return obj.id !== workflow_role_id
            });
        },
    },
    mounted() {
    },
    props: {
      model_chart: {
        type: String,
        required: true
      },
      route: {
        type: String,
        required: true
      },
      actor_people: {
        type: Array,
        required: true
      },
      all_people: {
        type: Array,
        required: true
      },
      charts_id: {
        type: Array,
        required: true
      },
      workflow_roles: {
        type: Array,
        required: true
      },
    }

  }
</script>

<style>
	.hidden {
		display: none;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>